var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6", "no-margin": "" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-page-settings-default", {
                    model: {
                      value: _vm.layout,
                      callback: function ($$v) {
                        _vm.layout = $$v
                      },
                      expression: "layout",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-default-language", {
                    model: {
                      value: _vm.layout,
                      callback: function ($$v) {
                        _vm.layout = $$v
                      },
                      expression: "layout",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6", "no-margin": "" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-page-settings-background-image", {
                    model: {
                      value: _vm.layout,
                      callback: function ($$v) {
                        _vm.layout = $$v
                      },
                      expression: "layout",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-page-settings-font", {
                    model: {
                      value: _vm.layout,
                      callback: function ($$v) {
                        _vm.layout = $$v
                      },
                      expression: "layout",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }